import * as React from "react";
const SvgSolidArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 5.5L3.353 10.5H12.647L8 5.5Z", fill: "currentColor" }));
export default SvgSolidArrowUp;
